import React, { useEffect } from 'react';
import Routes from './Routes/Routes';
import ReusableDrawer from "./Context/DrawerContext/ReusableDrawer";
import { DrawerProvider } from "./Context/DrawerContext/DrawerContext";
import { PropagateLoader } from "react-spinners";
import { LoaderProvider, useLoader } from "./Context/LoaderContext/LoaderContext";
import { ErrorProvider } from "./Context/ErrorContext/ErrorContext";
import { GlobalDebug } from "./utils/remove-consoles";
import {useAutoRefreshToken} from "./hooks/UseAutoRefreshToken";
import utils from "./utils/commonFunctions";
import {useAuthProvider} from "./providers/AuthProvider";

export const GlobalLoader = () => {
    const { loading } = useLoader();
    return loading ? (
        <div style={{
            position: 'fixed',
            top: '0',
            left: '0',
            width: '100%',
            height: '100%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: '1000'
        }}>
            <PropagateLoader size={8} color="#63B3ED" />
        </div>
    ) : null;
};

const App = () => {

    const { loading } = useAuthProvider();

    /*useEffect(() => {
        const disableContextMenu = (e) => e.preventDefault();
        const handleKeyDown = (e) => {
            if (e.keyCode === 123 || // F12
                ((e.ctrlKey || e.metaKey) && e.shiftKey && ['I', 'J', 'C'].includes(e.key)) || // Ctrl+Shift+I/J/C
                ((e.ctrlKey || e.metaKey) && e.key === 'u')) { // Ctrl+U
                e.preventDefault();
            }
        };

        document.addEventListener('contextmenu', disableContextMenu);
        document.addEventListener('keydown', handleKeyDown);

        return () => {
            document.removeEventListener('contextmenu', disableContextMenu);
            document.removeEventListener('keydown', handleKeyDown);
        };
    }, []);

    useEffect(() => {
        (process.env.NODE_ENV === "production" ||
            process.env.NODE_ENV === "development") &&
            GlobalDebug(false);
        console.log = function () { };
        console.warn = function () { };
        console.error = function () { };
        console.debug = function () { };

    }, []);*/

    useEffect(() => {
        const disableContextMenu = (e) => e.preventDefault();

        const handleKeyDown = (e) => {
            const tag = e.target.tagName.toLowerCase();
            const isEditable = (
                ['input', 'textarea', 'select', 'button'].includes(tag) || e.target.isContentEditable
            );

            const isDevShortcut =
                e.key === 'F12' ||
                ((e.ctrlKey || e.metaKey) && e.shiftKey && ['I', 'J', 'C'].includes(e.key.toUpperCase())) ||
                ((e.ctrlKey || e.metaKey) && e.key.toLowerCase() === 'u');

            if (isDevShortcut && !isEditable) {
                e.preventDefault();
                if (process.env.NODE_ENV === 'development') {
                    console.warn(`DevTools shortcut blocked: ${e.key}`);
                }
            }
        };

        document.addEventListener('contextmenu', disableContextMenu);
        document.addEventListener('keydown', handleKeyDown);

        return () => {
            document.removeEventListener('contextmenu', disableContextMenu);
            document.removeEventListener('keydown', handleKeyDown);
        };
    }, []);

    const loadAppKeys = async () =>{
        await utils.loadAPIKey()
    }

    useEffect(() => {
        loadAppKeys()
        if (process.env.NODE_ENV === 'production' || process.env.NODE_ENV === 'development') {
            console.log = () => {};
            console.warn = () => {};
            console.debug = () => {};

            const originalError = console.error;

            console.error = (...args) => {

                // Let React and Axios still log real stack trace
                originalError(...args);
            };
        }
    }, []);


    if (loading) {
        return <GlobalLoader/>;
    }

    return (
        <ErrorProvider>
            <LoaderProvider>
                <DrawerProvider>
                    <GlobalLoader />
                    <ReusableDrawer />
                    <Routes />
                </DrawerProvider>
            </LoaderProvider>
        </ErrorProvider>
    );
};

export default App;
